// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__29wZ2","active":"tabs_active__tBdZ5"};